import PCHostTypeDropdown from 'components/PCHostTypeDropdown';
import PolicyFilterDropdown from 'components/PolicyFilterDropdown';
import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import SearchAndFilters from 'components/SearchAndFilters/index';
import { useAtom, useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Row, Col } from 'reactstrap';

import {
  filterValuesAtom,
  policyIdFilterAtom,
  sourceTypeAtom,
  agentKeyAtom,
  useOnFilterChangeResetRelatedAtoms,
  useOnPolicyFilterChangeResetRelatedAtoms,
  useOnSourceTypeChangePCFindingsResetAtoms,
} from './state';

const PolicyFilter: React.FC = () => {
  const [policyId, setPolicyId] = useAtom(policyIdFilterAtom);
  const resetPolicyFilterAtoms = useOnPolicyFilterChangeResetRelatedAtoms();

  return (
    <Suspense fallback={<>...</>}>
      <PolicyFilterDropdown
        selectedPolicyId={policyId}
        onChange={(value) => {
          setPolicyId(value);
          resetPolicyFilterAtoms();
        }}
      />
    </Suspense>
  );
};

const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const setFilterValues = useSetAtom(filterValuesAtom);
  const resetOnFilterChangeAtoms = useOnFilterChangeResetRelatedAtoms();
  const resetSourceTypeChangeAtoms =
    useOnSourceTypeChangePCFindingsResetAtoms();
  const [sourceType, setSourceType] = useAtom(sourceTypeAtom);
  const [agentKey, setAgentKey] = useAtom(agentKeyAtom);

  const handleFilterChange = () => {
    setFilterValues({ ...filtersConfig.getActiveFilterValues() });
    resetOnFilterChangeAtoms();
  };

  const handleHostTypeChange = (newSourceType: string, newAgentKey: string) => {
    void setSourceType(newSourceType);
    void setAgentKey(newAgentKey);
  };

  return (
    <Suspense fallback={<></>}>
      <Row className="text-left">
        <Col xs="12" md="3">
          <Suspense fallback={<>...</>}>
            <PolicyFilter />
          </Suspense>
        </Col>

        <Col xs="12" md="3">
          <Suspense fallback={<>...</>}>
            <PCHostTypeDropdown
              value={sourceType}
              agentKey={agentKey}
              onChange={handleHostTypeChange}
              onSourceTypeChange={resetSourceTypeChangeAtoms}
            />
          </Suspense>
        </Col>

        <Col xs="12" md="6">
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
